<template>
  <div class="about-us">
    <div class="swpier">
      <img :src="swiperImage" alt="">
    </div>
    <div class="menu">
      <div class="menu-lsit">
        <div class="menu-lsit-item" :class="menuIndex == index ? 'menu-lsit-item_' : ''" v-for="(item, index) in menuList"
          :key="index" @click="getMenu(item, index)">
          {{ item.name }}
        </div>
      </div>
    </div>
    <companyProfile v-if="menuIndex == 0 && menuId != ''" :productId="menuId"></companyProfile>
    <companystrength v-if="menuIndex == 1 && menuId != ''" :productId="menuId"></companystrength>
    <contactus v-if="menuIndex == 2 && menuId != ''" :productId="menuId" :title="title"></contactus>
    <footerBotom></footerBotom>
  </div>
</template>
<script>
import companyProfile from './components/CompanyProfile.vue'
import companystrength from './components/Companystrength.vue'
import contactus from './components/contactus.vue'
import { aboutCate, nav } from '@/request/api'
import footerBotom from '@/components/footer.vue'
export default {
  components: {
    companyProfile,
    companystrength,
    contactus,
    footerBotom
  },
  data() {
    return {
      menuList: [],
      menuIndex: 0,
      menuId: "",
      title: "",
      swiperImage: ""
    }
  },
  created() {
    if (this.$route.query.type) {
      this.menuIndex = this.$route.query.type
    }
    this.getNav()
    this.getMenuList()
  },
  mounted() {

  },
  methods: {
    getNav() {
      nav({}).then(res => {
        this.swiperImage = res.data[4].image
      })
    },
    getMenuList() {
      aboutCate({}).then(res => {
        if (res.code == 1) {

          console.log(this.menuList)
          this.menuId = res.data[this.menuIndex].id
          this.menuList = res.data
        }
      })
    },
    getMenu(item, index) {
      if (index == this.menuIndex) {
        return
      }
      this.menuId = item.id
      this.title = item.name
      this.menuIndex = index
    }
  }
}
</script>
<style lang="scss" scoped>
.swpier {
  margin-top: 90px;
  width: 100%;

  img {
    width: 100%;
    height: 100%;
    vertical-align: middle;
  }
}

.menu {
  height: 57px;
  background: #131823;

}

.menu-lsit {
  display: flex;
  align-items: center;
  max-width: 1400px;
  margin: 0 auto;
  justify-content: center;


}

.menu-lsit-item {
  display: block;
  text-align: center;
  width: 164px;
  height: 57px;
  line-height: 57px;
  font-size: 16px;

  color: #FFFFFF !important;
  cursor: pointer;
}

.menu-lsit-item_ {
  background: #DB2733 !important;
}

.menu-lsit-item:hover {
  background: #DB2733;
}
</style>



// WEBPACK FOOTER //
// src/view/aboutUs/index.vue